module.exports = __webpack_public_path__ + "static/media/Optix_logo.4c977f77.png";